import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1;
let TodoModel = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('boolean'), _dec5 = belongsTo('contact', {
  inverse: null,
  async: true
}), _dec6 = attr('string'), _dec7 = attr('string'), _dec8 = hasMany('contact', {
  inverse: null,
  async: true
}), _dec9 = hasMany('reminder', {
  inverse: 'todo',
  async: false
}), _dec0 = belongsTo('todolist', {
  inverse: 'todos',
  async: false
}), _dec1 = attr('boolean', {
  defaultValue: false
}), _class = class TodoModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "date", _descriptor, this);
    _initializerDefineProperty(this, "text", _descriptor2, this);
    _initializerDefineProperty(this, "created_at", _descriptor3, this);
    _initializerDefineProperty(this, "is_completed", _descriptor4, this);
    _initializerDefineProperty(this, "completed_by", _descriptor5, this);
    _initializerDefineProperty(this, "completed_at", _descriptor6, this);
    _initializerDefineProperty(this, "text_field", _descriptor7, this);
    _initializerDefineProperty(this, "contacts", _descriptor8, this);
    _initializerDefineProperty(this, "reminders", _descriptor9, this);
    _initializerDefineProperty(this, "todolist", _descriptor0, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor1, this);
  }
  get label() {
    return this.text || '';
  }
  get reminders_number() {
    return this.reminders?.length || 0;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "date", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "text", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "created_at", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "is_completed", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "completed_by", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "completed_at", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "text_field", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "contacts", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "reminders", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "todolist", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { TodoModel as default };
//# sourceMappingURL=todo.js.map
